import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=68e226fa&scoped=true&"
import script from "./mail.vue?vue&type=script&lang=js&"
export * from "./mail.vue?vue&type=script&lang=js&"
import style0 from "./mail.vue?vue&type=style&index=0&id=68e226fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e226fa",
  null
  
)

export default component.exports